import React, {useState, useEffect} from 'react';
import {Text, View, Dimensions, StyleSheet} from 'react-native';
import {Col, Container, Row} from 'react-bootstrap';
import HomeHeader from '../../components/HomeHeader';
import {
  AiOutlineMail,
  AiOutlinePhone,
  AiFillEnvironment,
  AiFillFlag,
  AiOutlineEnvironment,
} from 'react-icons/ai';
import {getAccessToken} from '../../database/DataBase';
import { getLcoContactDetails } from '../../network/Network';
import { ActivityIndicator } from 'react-native';

const HEIGHT = Dimensions.get('window').height;

export default function ContactUsScreen(props) {
  
  const [operator, setOperator] = useState({});
  const [isLoading, setIsLoading] = useState(false);
  
  useEffect(() => {
    setIsLoading(true);
    getLcoContactDetails()
      .then((json) => {
        setOperator(json.data);
        setIsLoading(false);
      });
  }, []);

  return (
    <View
      style={{
        height: HEIGHT,
      }}>
      <HomeHeader navigation={props.navigation}/>
      <Text style={styles.headerTitle}>We’re always ready to help you</Text>
      <Container style={{marginTop: 30}}>
        {
          isLoading ? (
            <ActivityIndicator size={'large'}/>
          ) : (
            <Row>
              <Col md={3}>
                <View style={styles.card}>
                  <Text style={styles.cardHeader}>Mail Us</Text>
                  <AiOutlineMail color="#e10808" size={55} />
                  <Text style={styles.description}>
                    Had any query mail us at {'\n'} {operator.email}
                  </Text>
                </View>
              </Col>
              <Col md={3}>
                <View style={styles.card}>
                  <Text style={styles.cardHeader}>Helpline Numbers</Text>
                  <AiOutlinePhone color="#e10808" size={55} />
                  <Text style={styles.description}>{operator.mobile_no}</Text>
                </View>
              </Col>
              <Col md={3}>
                <View style={styles.card}>
                  <Text style={styles.cardHeader}>Office Address</Text>
                  <AiOutlineEnvironment color="#e10808" size={55} />
                  <Text style={styles.description}>
                    {operator.addr+', '+operator.addr1+", "+operator.addr2+", "+operator.addr3}
                  </Text>
                </View>
              </Col>
              <Col md={3}>
                <View style={styles.card}>
                  <Text style={styles.cardHeader}>Raise a complaint</Text>
                  <AiFillFlag color="#e10808" size={55} />
                  <Text style={styles.description}>
                    Had an issues click here to raise a complaint
                  </Text>
                </View>
              </Col>
            </Row>
          )
        }
        
      </Container>
    </View>
  );
}

const styles = StyleSheet.create({
  faqAnswer: {
    color: 'lightgray',
    marginTop: 15,
    marginLeft: 20,
  },
  headerTitle: {
    color: 'lightgray',
    letterSpacing: 1,
    fontWeight: 'bold',
    fontSize: 30,
    alignSelf: 'center',
    marginVertical: 30,
  },
  card: {
    alignItems: 'center',
    marginHorizontal: 10,
    padding: 20,
    boxShadow: `${1}px ${1}px ${10}px ${'#8080803b'}`,
    height: 230,
    // justifyContent: 'center',
  },
  cardHeader: {
    fontSize: 20,
    fontWeight: 'bold',
    letterSpacing: 1,
    color: 'lightgray',
    marginBottom: 25,
  },
  description: {
    marginTop: 15,
    color: 'lightgray',
    textAlign: 'center',
    lineHeight: 24,
    fontSize: 13,
  },
});
